import { BpmRoleAssignmentRole } from "./role/bpm-role-assignment-role";
import { BpmRoleAssignmentDepartment } from "./department/bpm-role-assignment-department";

/**
 * Поля назначения BPM-роли, каждое своим компонентом: показ решается один раз здесь,
 * а не в колонках таблицы. Подкомпонент принимает сущность целиком —
 * `<BpmRoleAssignment.Role data={assignment} />`.
 */
export const BpmRoleAssignment = {
  Role: BpmRoleAssignmentRole,
  Department: BpmRoleAssignmentDepartment,
};
